import { render, staticRenderFns } from "./ReferenceValues.vue?vue&type=template&id=026150ca&scoped=true"
import script from "./ReferenceValues.vue?vue&type=script&lang=js"
export * from "./ReferenceValues.vue?vue&type=script&lang=js"
import style0 from "./ReferenceValues.vue?vue&type=style&index=0&id=026150ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026150ca",
  null
  
)

export default component.exports